@if (!mhsControl.additionalDetailsAreRepeatable) {
  @for (detail of mhsControl.additionalDetails; track detail) {
    <app-generic-form [control]="detail" [parentForm]="parentForm"></app-generic-form>
  }
} @else {
  @for (rq of mhsService.allRepeatableQuestions; track rq) {
    @if (parentKey === rq.questionNumber) {
      @for (repeat of rq.repeats; track repeat; let dtlIndex = $index) {
        @for (detail of repeat; track detail) {
          <app-generic-form [control]="detail" [parentForm]="parentForm"></app-generic-form>
        }
        <div class="row d-flex align-items-center">
          @if (rq.repeats.length > 1) {
            <div class="col">
              <prism-ui-button
                button-width="content"
                icon-name="trash-can"
                key-id="delete-button"
                size="md"
                variant="text"
                type="button"
                is-waiting="false"
                is-icon-right-aligned="false"
                (click)="removeDetails(dtlIndex, questionType)"
              >{{removeButtonProps.text}}</prism-ui-button>
            </div>
          }
          @if (dtlIndex < mhsControl.repeatMaximum-1 && dtlIndex === rq.repeats.length-1) {
            <div class="col">
              <prism-ui-button
                button-width="content"
                icon-name="plus"
                key-id="add-button"
                size="md"
                variant="text"
                type="button"
                is-waiting="false"
                is-icon-right-aligned="false"
                (click)="addDetails()"
              >{{addButtonProps.text}}</prism-ui-button>
            </div>
          }
        </div>
      }
    }
  }
}
<prism-ui-modal key-id="delete-modal" has-dark-overlay="true">
  <prism-ui-heading
    slot="modal-header"
    key-id="delete-modal"
    font-size="sm"
    font-weight="strong"
    >{{deleteModalContentHeading}}</prism-ui-heading
    >
    <prism-ui-copy
      slot="modal-body"
      key-id="delete-modal"
      [innerHTML]="deleteModalContentBody"
      >
    </prism-ui-copy>
    <div slot="modal-footer">
      <div class="modalButtonStyling">
        <prism-ui-button
          button-width="full"
          key-id="cancel-button"
          size="md"
          variant="secondary"
          type="button"
          is-icon-right-aligned="false"
          (click)="onCancelModal('delete-modal')"
        >Cancel</prism-ui-button>
        <prism-ui-button class="leftPaddingSmall"
          button-width="full"
          key-id="continue-button"
          size="md"
          variant="primary"
          type="button"
          is-icon-right-aligned="false"
          (click)="yesDelete('delete-modal')"
        >Yes, Delete</prism-ui-button>
      </div>
    </div>
  </prism-ui-modal>

  <prism-ui-modal key-id="diagnosis-modal" has-dark-overlay="true">
    <prism-ui-heading
      slot="modal-header"
      key-id="diagnosis-modal"
      font-size="sm"
      font-weight="strong"
      >{{diagnosisModalContentHeading}}</prism-ui-heading
      >
      <prism-ui-copy
        slot="modal-body"
        key-id="diagnosis-modal"
        [innerHTML]="diagnosisModalContentBody"
        >
      </prism-ui-copy>
      <div slot="modal-footer">
        <div class="modalButtonStyling">
          <prism-ui-button
            button-width="full"
            key-id="cancel-button"
            size="md"
            variant="secondary"
            type="button"
            is-icon-right-aligned="false"
            (click)="onCancelModal('diagnosis-modal')"
          >Cancel</prism-ui-button>
          <prism-ui-button class="leftPaddingSmall"
            button-width="full"
            key-id="continue-button"
            size="md"
            variant="primary"
            type="button"
            is-icon-right-aligned="false"
            (click)="yesDelete('diagnosis-modal')"
          >Yes, Delete</prism-ui-button>
        </div>
      </div>
    </prism-ui-modal>